import lazyModule from './lazyModule.js';

// Sitewide / above-the-fold chrome — keep in the main bundle
import AllTypesEnvironmentsList from './modules/AllTypesEnvironmentsList.js';
import BusinessStatus from './modules/BusinessStatus.js';
import FeaturedCardsTabs from './modules/FeaturedCardsTabs.js';
import HeaderMoreNavigation from './modules/HeaderMoreNavigation.js';
import HeaderPrimaryNavigation from './modules/HeaderPrimaryNavigation.js';
import MobileMenu from './modules/MobileMenu.js';

/**
 * Page-specific and heavy modules are dynamic-imported so the homepage (and
 * other pages without those data-module hooks) do not download gallery,
 * Algolia grid, Embla, etc. bundles up front.
 *
 * Header Algolia search is deferred until idle / first interaction so it stays
 * off the LCP critical path while remaining available sitewide.
 */
const modules = {
  allTypesEnvironmentsList: AllTypesEnvironmentsList,
  businessStatus: BusinessStatus,
  featuredCardsTabs: FeaturedCardsTabs,
  headerMoreNavigation: HeaderMoreNavigation,
  headerPrimaryNavigation: HeaderPrimaryNavigation,
  mobileMenu: MobileMenu,

  mobileSearch: lazyModule(() => import('./modules/MobileSearch.js'), { defer: true }),
  primarySearch: lazyModule(() => import('./modules/PrimarySearch.js'), { defer: true }),

  accordion: lazyModule(() => import('./modules/Accordion.js')),
  comparisonSlider: lazyModule(() => import('./modules/ComparisonSlider.js')),
  filterablePostGrid: lazyModule(() => import('./modules/FilterablePostGrid.js')),
  filterableProjectGrid: lazyModule(() => import('./modules/FilterableProjectGrid.js')),
  filterableQuestionsAnswers: lazyModule(() => import('./modules/FilterableQuestionsAnswers.js')),
  filterableTerms: lazyModule(() => import('./modules/FilterableTerms.js')),
  imageGallery: lazyModule(() => import('./modules/ImageGallery.js')),
  searchResults: lazyModule(() => import('./modules/SearchResults.js')),
  testimonialsSlider: lazyModule(() => import('./modules/TestimonialsSlider.js')),
  VideoModal: lazyModule(() => import('./modules/VideoModal.js')),
};

export default modules;
